import React from 'react';
import { useUserContext } from 'common/contexts/UserContext';
import { ContainerUsage } from './ContainerUsage';
import { CompanyLabel } from './CompanyLabel';

/**
 * Renders the widget that displays the total container usage along with the
 * company label
 */
export const ContainerTracking: React.FC = () => {
  const { user } = useUserContext();

  // Render nothing if there is no user
  if (!user) {
    return null;
  }

  return (
    <div className="flex flex-col space-y-4">
      <CompanyLabel user={user} />
      <ContainerUsage />
    </div>
  );
};
ContainerTracking.displayName = 'ContainerTracking';
